type storageProps = {
  key: string;
  value: object;
  expire?: string;
};
export const setStorage = ({ ...payload }: storageProps) => {
  const { key, value } = payload;
  if (!value) {
    return;
  }
  sessionStorage.setItem(key, JSON.stringify(value));
};

export const getStorage = (key: string): string | null => {
  return sessionStorage.getItem(key || '{}');
};

export const deleteStorage = (key: string) => {
  sessionStorage.removeItem(key);
};
export const localSetStorage = ({ ...payload }: storageProps) => {
  const { key, value } = payload;
  if (!value) {
    return;
  }
  localStorage.setItem(key, JSON.stringify(value));
};

export const baseLocalStorage = (key: string) => {
  return localStorage.getItem(key);
};
export const localGetStorage = (key: string) => {
  const re = localStorage.getItem(key);
  if (!re) {
    return null;
  }
  return JSON.parse(re);
};

export const localDeleteStorage = (key: string) => {
  localStorage.removeItem(key);
};
type localReturnProps = {
  auth: string;
  point: string;
};

export const authLocalStorage = (): localReturnProps => {
  const re = localGetStorage('auth');
  if (!re) {
    return {
      auth: '',
      point: '',
    };
  }
  return re;
};

type urlSessionStorageProps = {
  url: string;
};
export const urlSessionStorage = (): urlSessionStorageProps => {
  const re = getStorage('url');
  if (!re) {
    return { url: '/signInSns' };
  }
  return JSON.parse(re);
};

export const langSessionStorage = () => {
  const re = getStorage('lang');
  if (!re) {
    return {
      lang: 'en',
    };
  }
  return JSON.parse(re);
};

export type loginStorageProps = {
  key: 'login';
  value: {
    email: string;
    keep: boolean;
    auth: string;
    sns?: string;
  };
};
export type resLoginStorageProps = {
  email: string;
  keep: boolean;
  auth: string; // bio, pin, email, oauth
  sns?: string; // naver, google
};
const initLoginStorage = () => {
  return {
    email: '',
    keep: false,
    auth: '',
    sns: '',
  };
};
export const loginLocalStorage = (): resLoginStorageProps => {
  const re: resLoginStorageProps | null = localGetStorage('login');
  if (!re) {
    return {
      ...initLoginStorage(),
    };
  }
  return re;
};

export const bioLocalStorage = () => {
  const re = localGetStorage('bio_check');
  if (!re) {
    return null;
  }
  return re;
};

export const setBioLocalStorage = (key: string, value: number) => {
  if (!key && !value) {
    return;
  }
  localStorage.setItem(key, JSON.stringify(value));
};

export const localGetArrayStorage = (key: string): any[] => {
  const value = localGetStorage(key);
  return value ? value : [];
};

export const localSetArrayStorage = (key: string, value: string) => {
  const storage = localGetArrayStorage(key);
  storage.push(value);
  const payload = {
    key,
    value: storage,
  };
  localSetStorage(payload);
};
